import React, { useMemo, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { FOLDER_USER_ROLE } from '../../constants/UserRoles';
import { parseString } from '../../utils/stringHelper';
import styles from './UsersList.module.scss';
import { useUserContext } from '../../context/UserContext';
import Tooltip from '../Tooltip/Tooltip';

const maxNumberOfDisplayedUsers = 4;

const UsersList = ({ isFolderEditable, users }) => {
  const [isHover, setIsHover] = useState(false);

  const { appConfig } = useUserContext();

  const { t } = useTranslation();

  const handleMouseOver = () => {
    setIsHover(true);
  };

  const handleMouseOut = () => {
    setIsHover(false);
  };

  const getRoles = role => {
    if (role === FOLDER_USER_ROLE.EDITOR.TYPE && isFolderEditable) {
      return t('folder.role.admin');
    }

    if (role === FOLDER_USER_ROLE.EDITOR.TYPE) {
      return t('folder.role.editor');
    }

    if (role === FOLDER_USER_ROLE.VIEWER.TYPE) {
      return t('folder.role.viewer');
    }

    return t('folder.role.owner');
  };

  const generatedUserString = useMemo(() => {
    return users.map((user, index) => {
      if (index === maxNumberOfDisplayedUsers) {
        return `, +${users.length - maxNumberOfDisplayedUsers}`;
      }

      if (index > maxNumberOfDisplayedUsers) {
        return null;
      }

      if (index === 0) {
        if (users.length === 1) {
          const string = appConfig?.name ? ' / ' + appConfig.name : '';
          return parseString(user?.name) + string;
        }
        return parseString(user?.name);
      }

      return `, ${parseString(user?.name)}`;
    });
  }, [users, maxNumberOfDisplayedUsers]);

  return (
    <div className={styles.usersContainer} onMouseEnter={handleMouseOver} onMouseLeave={handleMouseOut}>
      <h3 className={styles.usersString}>{generatedUserString}</h3>
      <Tooltip isHover={isHover} moveable={false} classNameTooltip={styles.fullList}>
        {users.map(({ name, folderRole }) => (
          <span key={`${name}_${folderRole}`} className={styles.listItem}>
            {parseString(name)} ({getRoles(folderRole)})
          </span>
        ))}
      </Tooltip>
    </div>
  );
};

export default UsersList;
